<template>
  <div>
    <UnprocessedOverviewComponent v-if="afdMessages.length === 0"
                                  v-on:afd-messages-selected="onAFDMessagesSelected"/>
    <a-collapse v-model="activeKey">
      <a-collapse-panel v-for="(afdMessage, index) in afdMessages" :key="index"
                        :header="afdMessage.type_description + ': ' + afdMessage.message_id">
        <ProcessAFDMessageComponent :afd-message="afdMessage" :key="index"/>
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import store from "../store";
import afdMessageApi from "~/api/afd_message";
import UnprocessedGroupedAFDMessageRowComponent
  from "~/modules/sivi/components/UnprocessedGroupedAFDMessageRowComponent";
import UnprocessedOverviewComponent from "./UnprocessedOverviewComponent";
import ProcessAFDMessageComponent from "./ProcessAFDMessageComponent";
// import store from '../store';

export default {
  name: "ProcessingOverviewComponent",
  props: {
    processed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      afdMessages: [],
      currentPage: null,
      currentRequestData: {},
      allSelected: false,
      loading: true,
    }
  },
  computed: {
    ...mapGetters({
      staticSearches: '$_templating/staticSearches',
    }),
    indeterminate() {
      return this.allSelected === false
          && this.currentSelectionDiff !== this.afdMessages.length
          && this.currentSelectionDiff > 0;
    },
    currentSelectionDiff() {
      return this.afdMessages.filter(i => store.state.selectedAFDMessages.findIndex(x => x.id === i.id) < 0).length;
    },
    selectedAFDMessages() {
      return store.state.selectedAFDMessages;
    },
    displayPagination() {
      return typeof this.currentRequestData.meta !== "undefined";
    },
    hasSelection() {
      return this.selectedAFDMessages.length > 0;
    },
    selectedUnlinkableAfdMessages() {
      return this.selectedAFDMessages.filter(email => typeof email.customer !== "undefined" && email.customer !== null)
    },
    hasUnlinkableSelection() {
      return this.selectedUnlinkableAfdMessages.length > 0;
    },
  },
  created() {
    const STORE_KEY = '$_search';
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }

    if (this.siviMessage === null && this.afdMessageId === null) {
      throw new Error('Either the sivi message or the afd message id must be provided via the props')
    } else if (this.sourceSiviMessage !== null) {
      this.siviMessage = this.sourceSiviMessage
    }
  },
  mounted() {
  },
  components: {
    ProcessAFDMessageComponent,
    UnprocessedOverviewComponent,
    UnprocessedGroupedAFDMessageRowComponent
  },
  methods: {
    onAFDMessagesSelected(afdMessages) {
      this.afdMessages = afdMessages;
    },
    onUnmatchAllClick() {

    },
    onProcessAllClick() {

    },
    selectAFDMessage(afdMessage) {
      store.state.selectedAFDMessages.push(afdMessage);

      if (this.currentSelectionDiff === 0) {
        this.allSelected = true;
      }
    },
    selectAFDMessages(afdMessages) {
      for (let i in this.afdMessages) {
        this.selectAFDMessage(this.afdMessages[i]);
      }
    },
    deselectAFDMessage(afdMessage) {
      this.allSelected = false;

      store.state.selectedAFDMessages.splice(store.state.selectedAFDMessages.findIndex(x => x.id === afdMessage.id), 1);
    },
    deselectAFDMessages(afdMessages) {
      for (let i in this.afdMessages) {
        this.deselectAFDMessage(this.afdMessages[i]);
      }
    },
    onSelectAllChanged() {
      this.allSelected = !this.allSelected;

      for (let i in this.afdMessages) {
        let afdMessage = this.afdMessages[i];

        if (this.allSelected === true && store.state.selectedAFDMessages.findIndex(x => x.id === afdMessage.id) < 0) {
          this.selectAFDMessage(afdMessage);
        } else if (this.allSelected === false) {
          this.deselectAFDMessage(afdMessage);
        }
      }
    },
    onSelectionChanged(afdMessage, selected, shiftKey) {
      if (selected === true) {
        this.selectAFDMessage(afdMessage);
      } else {
        this.deselectAFDMessage(afdMessage);
      }
    },
    onProcessed() {

    },
    onUnmatched() {

    }
  }
}
</script>

<style scoped>
.csv-export-component {
}

table.table th, table.table td {
  padding: 1.5rem 1rem;
}
</style>
